// removed by extract-text-webpack-plugin
module.exports = {"TextLink":"TextLink__TextLink__3bg06","ButtonLink":"TextLink__ButtonLink__1Qf9i","TextButton":"TextLink__TextButton__14B3p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TextLink/TextLink.css
// module id = 388
// module chunks = 0